import { render, staticRenderFns } from "./GeoLink.vue?vue&type=template&id=6dfb21a3&"
import script from "./GeoLink.vue?vue&type=script&lang=js&"
export * from "./GeoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports